/**
 * ハコツル TOP about セクション: 鶴 Lottie + ロゴブロックのスクロール連動アニメ
 *
 * 仕様 (ユーザー要望):
 *  - about セクションが画面内に入ったタイミングからスクロール量に応じて
 *    鶴 wrap (data-crane-wrap) を「下に移動 + 拡大」 する
 *  - 開始: top = -500px * sp-scale (about の上に出ている初期位置)、 scale = 0.7
 *  - 終了: top = 0 (about 上端に着地)、 scale = 1.0
 *  - Lottie は about が画面内に入っている間、 scroll 発火時に 1 回再生する trigger 方式。
 *    再生完了 (complete event) で待機状態に戻り、 次の scroll で再再生される。
 *  - 全画面幅で動作 (SP / PC / PC 中間 zoom 範囲)
 *
 * スクロール計算は layout 単位 (window.scrollY と同じ単位) で行う。
 * PC 中間 zoom (assets/tailwind.css の @media 60-76.25rem で #about に zoom) では
 * getBoundingClientRect が描画値 (zoom 適用後) を返すため、 祖先の zoom を
 * 累積取得して逆数で layout 値に揃える。
 */
(function () {
  'use strict';

  /* 初期表示時の鶴 wrap オフセット (about の上端からの - 距離、 layout 上の px)。
     class の `-top-[calc(500px*var(--sp-scale))]` と同じ値。 */
  var INITIAL_TOP_PX = 500;
  var INITIAL_SCALE = 0.7;
  var TARGET_SCALE = 1.0;

  /* getEffectiveZoom / getPageY / getSpScale は assets/zoom-utils.js
     (window.HakotsuruZoom) に集約。 theme.liquid で本スクリプトより前に読み込む。 */
  var zoomUtil = window.HakotsuruZoom;

  function init() {
    var wrap = document.querySelector('[data-crane-wrap]');
    if (!wrap) return;
    var about = document.getElementById('about');
    if (!about) return;
    var lottie = wrap.querySelector('lottie-player');

    /* Lottie のフレーム制御: lottie-player の Web Component アップグレード完了後に
       内部 instance を取得する。 ready / load イベントを待つ。 */
    var lottieInstance = null;
    function tryGetLottie() {
      if (!lottie || typeof lottie.getLottie !== 'function') return;
      var inst = lottie.getLottie();
      if (inst && inst.totalFrames) {
        lottieInstance = inst;
        /* 自動再生を止めて trigger 制御に切り替える (scroll 進入時に play) */
        try { inst.pause(); } catch (e) {}
      }
    }
    if (lottie) {
      lottie.addEventListener('ready', tryGetLottie);
      lottie.addEventListener('load', tryGetLottie);
      tryGetLottie();
    }

    /* 再生完了で待機状態に戻し、 次の scroll で再生できるようにする。 */
    var isLottiePlaying = false;
    if (lottie) {
      lottie.addEventListener('complete', function () {
        isLottiePlaying = false;
      });
    }

    var rafId = null;

    /* 鶴アニメが半分進んだ時点 (progress = 0.5) で、 about 内の各要素を step 順に
       時間差でフェードインする。 about pin 開始時点 (progress 1.0) で content が
       ほぼ表示完了している状態にすることで、 内部 scrub / overlap で CTA 等が
       覆われる前にユーザーが視認できる時間を確保する。
       一度表示したら以降は戻さない (常時表示)。 */
    var FADE_REVEAL_PROGRESS = 0.5;
    var FADE_STEP_DELAY_MS = 200;
    var revealed = false;
    function revealSteps() {
      if (revealed) return;
      revealed = true;
      [1, 2, 3, 4].forEach(function (step, i) {
        window.setTimeout(function () {
          var els = document.querySelectorAll('[data-fade-step="' + step + '"]');
          els.forEach(function (el) { el.setAttribute('data-fade-visible', ''); });
        }, i * FADE_STEP_DELAY_MS);
      });
    }

    function compute() {
      rafId = null;
      var aboutTop = zoomUtil.getPageY(about);
      var vp = window.innerHeight;
      /* 開始: about top が viewport bottom に到達 (scrollY = aboutTop - vp)
         終了: about top が viewport top に到達 (scrollY = aboutTop) */
      var start = aboutTop - vp;
      var end = aboutTop;
      var range = end - start;
      var progress = range > 0 ? (window.scrollY - start) / range : 0;
      if (progress < 0) progress = 0;
      if (progress > 1) progress = 1;

      var spScale = zoomUtil.getSpScale();
      var topPx = -INITIAL_TOP_PX * spScale * (1 - progress);
      var scale = INITIAL_SCALE + (TARGET_SCALE - INITIAL_SCALE) * progress;

      wrap.style.top = topPx + 'px';
      /* 個別 scale プロパティを直接更新 (Tailwind の scale-70 class を上書き)。
         translate は class の `-translate-x-1/2` (CSS translate: -50%) のままで OK。 */
      wrap.style.scale = String(scale);

      /* Lottie は about が画面内に入っている間 (progress 0~1) の scroll で 1 回再生。
         再生中は isLottiePlaying で守り、 complete event で待機状態に戻る。 */
      if (lottieInstance && !isLottiePlaying && progress > 0 && progress < 1) {
        isLottiePlaying = true;
        try {
          lottieInstance.stop();
          lottieInstance.play();
        } catch (e) {}
      }

      if (progress >= FADE_REVEAL_PROGRESS) revealSteps();
    }

    function schedule() {
      if (rafId != null) return;
      rafId = window.requestAnimationFrame(compute);
    }

    compute();
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
